import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/bankagencies/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}bankagencies/delete`,
        endpoint: config.endpoints.backend + 'bankagencies/getall'
    }

    let list = {
        labelTitle: 'Lista de Agências',
        labelTitleButtonAdd: 'Incluir nova agência',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'bank',
                label: 'Banco'
            },
            {
                name: 'name',
                label: 'Agência'
            },
            {
                name: 'city',
                label: 'Cidade'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
